// extracted by mini-css-extract-plugin
export default {"TabelHolder":"SupportListTabel_TabelHolder__laHa9"};